import { Text } from '@connect-x-app/hybrid-ui';
import { IconName } from '@connect-x-app/shared-types';
import { COLORS } from '@connect-x-app/shared-ui';

import { Icon } from '../icon';

type Props = {
  icon: IconName;
  title: string;
  value?: string | null;
};

export const ProfileSection = ({ icon, title, value }: Props) => {
  return (
    <div className="profile-section-mid-list-item">
      <Icon className="profile-section-mid-list-item-icon" colorName={COLORS.romeo.$07} name={icon} size={2.5} />
      <div>
        <Text color={COLORS.romeo.$07} size="SM" uppercase weight="bold">
          {title}
        </Text>
        <Text color={COLORS.zulu.$08} size="SM">
          {value?.trim() ? value : '-'}
        </Text>
      </div>
    </div>
  );
};
